export default __webpack_public_path__ + "static/media/armman_logo.6173fbb5.png";